import { Axios } from "axios";
import { CherryPayApi } from "./models";
import { ApiResult, apiResult } from "./apiClient";

export class GeoLocationApiClient {
  private cherryPayClient: Axios;

  constructor(cherryPayClient: Axios) {
    this.cherryPayClient = cherryPayClient;
  }

  async getGeoLocations(
    businessId: string
  ): Promise<ApiResult<CherryPayApi.GeoLocation[]>> {
    const result = await this.cherryPayClient.get(
      `/v1/${businessId}/configuration/pass/geo-locations`
    );
    return apiResult<CherryPayApi.GeoLocation[]>(result);
  }
}
